import React, { useState } from 'react'
import { uploadFile } from '../../api/admin/adminUploadFile';
import { useAction, useAppState } from '../../hooks';
import { EInfoMessageType } from '../../types';
import { FILE_TYPE } from '../../utils';

type FileUploadProps = {
    setLoading: any,
    fileType: FILE_TYPE,
    path: string,
    uploadParams: any
}

export const FileUpload = ({ setLoading, fileType, path, uploadParams }: FileUploadProps) => {
    const [file, setFile] = useState<File | null>(null)
    const [fileContent, setFileContent] = useState<string>('')
    const { setInfoMessageAction } = useAction()
    const { state } = useAppState()

    // Funkce pro zpracování souboru při nahrání
    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const uploadedFile = event.target.files?.[0] // První soubor

        if (uploadedFile) {
            const reader = new FileReader();

            reader.onload = (e) => {
                if (e.target) {
                    setFileContent(e.target.result as string) // Uloží obsah souboru
                }
            };

            switch (fileType) {
                case FILE_TYPE.PDF: reader.readAsDataURL(uploadedFile); break;  // Přečte soubor jako text
                case FILE_TYPE.XML: reader.readAsText(uploadedFile); break;  // Přečte soubor jako text
                default: reader.readAsText(uploadedFile);
            }
            
            setFile(uploadedFile)  // Uloží soubor do stavu
        }
    };

    function getUploadingFile(): string | File  {
        switch (fileType) {
            case FILE_TYPE.PDF: return fileContent;
            case FILE_TYPE.XML: return file!;
            default: return file!;
        }
    }

    // Funkce pro odeslání souboru na backend
    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()
        setLoading(true)

        if (file && state?.token) {
            uploadFile({ file: getUploadingFile(), token: state.token, path: path, params: uploadParams }).then(res => {
                if (res.success) {
                    setInfoMessageAction({ type: EInfoMessageType.SUCCESS, message: res.errorMessage || 'Soubor nahrán', timeout: 15 });
                } else {
                    setInfoMessageAction({ type: EInfoMessageType.ERROR, message: res.errorMessage || 'Nahrání souboru se nezdařilo', timeout: 15 });
                }
                setLoading(false)
            })
        } else {
            setInfoMessageAction({ type: EInfoMessageType.ERROR, message: 'Není vybrán soubor', timeout: 15 });
            setLoading(false)
        }
    }

    return (
        <div className = "file_upload">
            <form onSubmit={handleSubmit} className = "file_upload__form">
                <input type="file" className='file_upload__form__input' accept={ fileType } onChange={handleFileChange} />
                <button type="submit" className='button'>Nahrát soubor</button>
            </form>

            {fileContent && fileType === FILE_TYPE.XML && (
                <div>
                    <h3>Obsah vybraného souboru:</h3>
                    <pre>{fileContent}</pre>
                </div>
            )}
        </div>
    );
}